import { useStore } from 'vuex';
import { computed } from 'vue';

export function useDataStore(scope) {
  const store = useStore();

  /**
   *
   * @param {string} id
   * @param {any} [data]
   */
  function set(id, value) {
    store.commit('traitsStore/set', { scope, key: id, value });
  }

  /**
   *
   * @param {string} id
   * @returns {any}
   */
  function get(id) {
    return store.state.traitsStore[scope][id];
  }

  /**
   * TODO: not sure why but sometimes vuex is undefined when using get() and computed at trait levle instead of here
   * @param {string} id
   * @returns {any}
   */
  function getComputed(id) {
    return computed(() => store.state.traitsStore[scope][id]);
  }

  /**
   *
   * @param {string} id
   * @returns {boolean}
   */
  function has(id) {
    return store.state.traitsStore[scope][id] !== undefined;
  }

  return {
    set,
    get,
    has,
    getComputed,
  };
}

export default useDataStore;
